export default [
  '234601',
  '253656',
  '253657',
  '253659',
  '253660',
  '270504',
  '270505',
  '270507',
  '270510',
];

//Some concierge boxes which are not allowed to be changed to credit, it will be fixed soon
